export default __webpack_public_path__ + "media/images/icons/motorcycle-solid-bcdd195cb4cab0db32f95f4b3fbf202f.svg";